import React, { PropsWithChildren } from 'react';

import clsxm from '@/lib/clsxm';

export type BadgeType =
  | 'default'
  | 'brand'
  | 'info'
  | 'warning'
  | 'error'
  | 'success';
export type BadgeSizeType = 'small' | 'xs';

export type BadgeProps = PropsWithChildren<{
  className?: string;
  variant: BadgeType;
  size: BadgeSizeType;
}>;

const Badge: React.FC<BadgeProps> = ({
  className,
  variant,
  children,
  size,
}) => {
  const getBadgeVariant = (variant: BadgeType) => {
    switch (variant) {
      case 'brand':
        return 'bg-ds-purple-100 text-ds-purple-600';
      case 'info':
        return 'bg-ds-blue-100 text-ds-blue-950';
      case 'warning':
        return 'bg-ds-yellow-100 text-ds-yellow-950';
      case 'error':
        return 'bg-ds-red-50 text-ds-red-500';
      case 'success':
        return 'bg-ds-green-50 text-ds-green-950';
      case 'default':
        return 'bg-ds-grey-50 text-ds-grey-950';
    }
  };

  const getBadgeSize = (size: BadgeSizeType) => {
    switch (size) {
      case 'small':
        return 'h-6 px-2 py-1';
      case 'xs':
        return 'h-6 px-2 py-1 text-xs uppercase';
      default:
        return 'h-8 px-4 py-2';
    }
  };

  return (
    <label
      className={clsxm(
        'inline-flex max-w-fit shrink-0 items-center justify-center rounded-lg bg-ds-grey-50 text-s font-semibold capitalize',
        getBadgeVariant(variant),
        getBadgeSize(size),
        className ?? ''
      )}
    >
      {children}
    </label>
  );
};

export default Badge;
